module.exports = __webpack_public_path__ + "media/swoosh2.e2fe340e.aac";